module.exports = __webpack_public_path__ + "static/media/spinner-darkbg-m.a20fb34d.gif";